import Record from "./base"

export class ReviewResponse extends Record {
  constructor(...args) {
    super(...args)
    const [model, props] = args
  }
}
